import React, { useEffect, useState } from 'react'
import { Flex, ResponsiveSVG } from 'ui/acro'
import Dublicate from '../../../assets/images/duplicate_icon.svg'
import Edit from '../../../assets/images/edit.svg'
import Delete from '../../../assets/images/delete_logo.svg'
import styled from 'styled-components'
import Drawer from '../../components_v2/Drawer/Drawer'
import { Button } from 'react-bootstrap'
import { axios } from 'api'
import AloMovesAnimation from 'components_v2/Search/common/AloMovesAnimation'

const FooterWrapper = styled.div`
  position: fixed;
  width: calc(100% - 48px);
  margin-bottom: 25px;
  margin-top: 25px;
`

const PlayListName = styled.input`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  padding: 12px 16px;
  border: 1px solid #a3a3a3;
  width: 100%;
  margin-top: 24px;
`

const PlayListDesc = styled.textarea`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  padding: 12px 16px;
  border: 1px solid #a3a3a3;
  width: 100%;
  margin-top: 24px;
  resize: none;
  height: 110px;
`

const SavePlaylistButton = styled(Button)({
  fontSize: ['18px'],
  fontFamily: 'Proxima-nova',
  textTransform: 'uppercase',
  color: (props) => (props.disabled ? '#4c4c4c' : '#fff'),
  background: (props) => (props.disabled ? '#ebebeb' : '#000'),
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
  letterSpacing: '0.9px',
  padding: '12px 32px',
  width: '100%'
})

const CreatePlaylistButton = styled(Flex)`
  font-family: ${(props) => props.theme.fonts.Proxima};

  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.396px;
  text-transform: capitalize;
  border: 0px solid #a3a3a3;
  gap: 16px;
  align-items: center;
  cursor: pointer;
  padding: 12px 0px;
`

const MyPracticeDrawer = ({
  isOpen,
  onClose,
  id,
  uuid,
  title,
  desc,
  onSuccess,
  isOwner
}) => {
  const [myPracticeAction, setMyPracticeAction] = useState('NONE')
  const [playListTitle, setPlayListTitle] = useState(
    `New Playlist ${new Date().toLocaleDateString('en-GB')}`
  )

  const [playListDesc, setPlayListDesc] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setPlayListTitle(() => title)
  }, [title])

  useEffect(() => {
    setPlayListDesc(desc)
  }, [desc])

  const handleTitleChange = (e) => {
    setPlayListTitle(e.target.value)
  }

  const handleDescChange = (e) => {
    setPlayListDesc(e.target.value)
  }

  const editPlayList = async () => {
    try {
      const res = await axios.put(`playlists/${uuid}`, {
        plan_entry_id: id,
        title: playListTitle,
        description: playListDesc
      })

      if (res.status === 200) {
        onClose()
        setMyPracticeAction('NONE')
        onSuccess(true)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const closeDrawer = () => {
    onClose()
    setMyPracticeAction('NONE')
  }

  const deletePlayList = async () => {
    setIsLoading(true)
    try {
      const res = await axios.delete(`playlists/${uuid}`)

      if (res.status === 200) {
        closeDrawer()
        onSuccess(true)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const duplicatePlayList = async () => {
    setIsLoading(true)
    try {
      const res = await axios.post(`playlists/${uuid}/duplicate`)

      if (res.status === 200) {
        closeDrawer()
        onSuccess(true)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const RemoveFromMyPlaylist = async () => {
    setIsLoading(true)
    try {
      const res = await axios.delete(`/playlists/${uuid}/followers`)
      if (res.status === 204) {
        closeDrawer()
        onSuccess(true)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Drawer
      isOpen={isOpen}
      title={myPracticeAction == 'NONE' ? title : 'Edit PlayList'}
      onClose={() => {
        closeDrawer()
      }}
    >
      <div>
        {myPracticeAction == 'NONE' ? (
          isLoading ? (
            <AloMovesAnimation />
          ) : (
            <>
              <CreatePlaylistButton onClick={duplicatePlayList}>
                <ResponsiveSVG SVG={Dublicate} width='25px' height='25px' />
                Duplicate
              </CreatePlaylistButton>
              {isOwner && (
                <>
                  <CreatePlaylistButton
                    onClick={() => setMyPracticeAction('EDIT')}
                  >
                    <ResponsiveSVG SVG={Edit} width='25px' height='25px' />
                    Edit
                  </CreatePlaylistButton>
                  <CreatePlaylistButton onClick={deletePlayList}>
                    <ResponsiveSVG SVG={Delete} width='25px' height='25px' />
                    Delete
                  </CreatePlaylistButton>
                </>
              )}
              {!isOwner && (
                <CreatePlaylistButton onClick={RemoveFromMyPlaylist}>
                  <ResponsiveSVG SVG={Delete} width='25px' height='25px' />
                  Remove From My Playlists
                </CreatePlaylistButton>
              )}
            </>
          )
        ) : (
          <>
            <div className='createPlayListWrapper'>
              <PlayListName
                type='text'
                value={playListTitle}
                onChange={handleTitleChange}
              />
              <PlayListDesc
                placeholder='Description (Max 500 Characters)'
                onChange={handleDescChange}
                value={playListDesc}
              ></PlayListDesc>
            </div>
            <FooterWrapper>
              <SavePlaylistButton onClick={editPlayList}>
                Edit Playlist
              </SavePlaylistButton>
            </FooterWrapper>
          </>
        )}
      </div>
    </Drawer>
  )
}
export default MyPracticeDrawer
